import { render, staticRenderFns } from "@/clickbuy/purchase/views/companion-form/companion-form.pug?vue&type=template&id=5874595c&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/clickbuy/purchase/views/companion-form/companion-form.scss?vue&type=style&index=0&id=5874595c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874595c",
  null
  
)

export default component.exports